import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { MediaView } from "../features/media/index.ts";
import { FolderTree } from "../features/taxonomy/index.ts";

export const Media: FC = () => (
  <PageContainer>
    <MediaView
      renderFolderTree={taxonomy => <FolderTree taxonomyId={taxonomy.id} />}
    />
  </PageContainer>
);
